import React from 'react';
import doctor from '../../../src/assets/images/doctor.png'
import appointment from '../../../src/assets/images/appointment.png'


const Apointment = () => {
    return (
        <div className='my-36'
       
       
        >
            <div className="hero min-h-screen bg-base-200 "  style={{
            background:`url(${appointment})`
        }}>
                <div className="hero-content flex-col lg:flex-row">
                    <div className="lg:w-1/2 p-5 lg:block hidden">
                    <img src={doctor} className="  h-full h rounded-lg w-full -mt-96" alt='' />
                    </div>
                    <div className='text-white w-1/2'>
                        <h1 className="lg:text-5xl font-bold">Make an appointment Today!</h1>
                        <p className="py-6">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsumis that it has a more-or-less normal distribution of letters,as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page</p>
                        <button className="btn btn-info text-white">Get Started</button>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Apointment;